import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';
import _ from 'lodash';

function getSelectedEvent(events) {
    if (!events)
        return null;

    return _.find(events, function (event) {
        return event.selected;
    });
}

const State = new Record({
    cpf: '',
    codigoApostila: '',
    participant: null,
    event: null,
    usualName: '',
    firstVerify: true,
    executingVerifyCpf: false,
    executingPrintBadge: false,
    executingLinkCourseware: false,
    events: null,
    processing: false,
});

class CredenciamentoViewStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
            case ActionTypes.SELECT_EVENTS_START:
                return state.clear();

            case ActionTypes.SELECT_EVENTS_FINISH:
                return state
                    .set('events', action.events)
                    .set('event', getSelectedEvent(action.events));

            case ActionTypes.SELECT_EVENT_START:
                return state.set('processing', true);

            case ActionTypes.SELECT_EVENT_FINISH:
                return state
                    .set('processing', false)
                    .set('event', action.event);

            case ActionTypes.SELECT_EVENT_FAILED:
                return state.set('processing', false);

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'cpf')
                    return state.set('cpf', action.value);

                if (action.field === 'codigoApostila')
                    return state.set('codigoApostila', action.value);

                if (action.field === 'usualName')
                    return state.set('usualName', action.value);

                return state;

            case ActionTypes.VERIFY_CPF_START:
                return state
                    .set('participant', null)
                    .set('executingVerifyCpf', true);

            case ActionTypes.VERIFY_CPF_FINISH:
                return state
                    .set('participant', action.participant)
                    .set('usualName', action.participant ? action.participant.usualName : '')
                    .set('cpf', '')
                    .set('firstVerify', false)
                    .set('executingVerifyCpf', false);

            case ActionTypes.VERIFY_CPF_NOT_FOUND:
                return state
                    .set('participant', null)
                    .set('usualName', '')
                    .set('firstVerify', false)
                    .set('executingVerifyCpf', false);

            case ActionTypes.VERIFY_CPF_FAILED:
                return state
                    .set('participant', null)
                    .set('usualName', '')
                    .set('executingVerifyCpf', false);

            case ActionTypes.PRINT_BADGE_START:
                return state.set('executingPrintBadge', true);

            case ActionTypes.PRINT_BADGE_FINISH:
                return state
                    .set('participant', null)
                    .set('usualName', '')
                    .set('firstVerify', true)
                    .set('executingPrintBadge', false);

            case ActionTypes.PRINT_BADGE_FAILED:
                return state.set('executingPrintBadge', false);

            case ActionTypes.LINK_COURSEWARE_START:
                return state.set('executingLinkCourseware', true);

            case ActionTypes.LINK_COURSEWARE_FINISH:
                return state
                    .set('participant', action.participant)
                    .set('usualName', action.participant ? action.participant.usualName : '')
                    .set('codigoApostila', '')
                    .set('executingLinkCourseware', false);

            case ActionTypes.LINK_COURSEWARE_FAILED:
                return state.set('executingLinkCourseware', false);

            case ActionTypes.CHOOSE_MENU_FINISH:
                if (action.cpf) return state.set('cpf', action.cpf);
                return state;

            default:
                return state;
        }
    }
}

export default new CredenciamentoViewStore();



// WEBPACK FOOTER //
// src/stores/CredenciamentoStore.js